import { processorEwalletDeposit, processEwalletDeposit } from '@/utils/api';
import Vue from 'vue';
import Vuex from 'vuex';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/utils/i18n';

Vue.use(Vuex);

const getDefaultState = () => {
  return {
    depositStatus: {
      loading: false,
      success: false,
      error: false,
      redirect: false,
    },
    allProcessors: [],
    allOptionsLoading: false,
    allOptions: [],
    currentProcessor: {},
  };
};
const state = getDefaultState();

const getters = {
  getField,
};
const mutations = {
  updateField,
  setAllProcessors(state, allProcessors) {
    state.allProcessors = allProcessors;
  },
  setCurrentProcessor(state, currentProcessor) {
    state.currentProcessor = currentProcessor;
  },
  setDepositStatus(state, row) {
    state.depositStatus = {
      ...state.depositStatus,
      ...row,
    };
  },
};

const actions = {
  tryGetProcessors({ commit }) {
    commit('setAllProcessors', []);
    processorEwalletDeposit().then(r => {
      if (r.data.IsSuccess) {
        const processors = r.data.Data;
        commit('setAllProcessors', processors);
      }
    });
  },
  tryDeposit({ commit, dispatch }, payload) {
    Vue.prototype.$gtmProvider.sendDepositEvent(
      {
        eventLabel: `${payload.gtm_event_name}_attempt`,
        eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
      },
      {
        label: `${payload.gtm_event_name}_attempt`,
        value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
      },
    );
    commit('setDepositStatus', {
      loading: true,
      success: false,
      error: false,
      redirect: false,
    });
    commit('depositStore/setPostDepositLoading', true, { root: true });
    processEwalletDeposit(payload)
      .then(r => {
        if (r.data.IsSuccess && r.data.Data.success) {
          Vue.prototype.$gtmProvider.sendDepositEvent(
            {
              eventLabel: `${payload.gtm_event_name}_success`,
              eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
            {
              label: `${payload.gtm_event_name}_success`,
              value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
          );
          dispatch('player/tryGetBalance', null, { root: true });
          let processorMessage = r.data.Data.processorResponseCode;
          if (r.data.Data.redirectUrl) {
            window.location.href = r.data.Data.redirectUrl;
          } else {
            commit('setDepositStatus', {
              processorMessage,
              error: false,
              success: i18n.t('DepositView.Ewallet.SuccessMessage'),
            });
          }
        } else {
          Vue.prototype.$gtmProvider.sendDepositEvent(
            {
              eventLabel: `${payload.gtm_event_name}_fail`,
              eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
            {
              label: `${payload.gtm_event_name}_fail`,
              value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
            },
          );
          let errorMessage = r.data.IsSuccess ? r.data.Data.message : r.data.ExceptionMessage[0];
          let processorMessage = r.data.IsSuccess ? r.data.Data.processorResponseCode : null;
          commit('setDepositStatus', {
            processorMessage,
            error: i18n.t('Exceptions.' + errorMessage),
            success: false,
            redirect: false,
          });
        }
      })
      .catch(err => {
        Vue.prototype.$gtmProvider.sendDepositEvent(
          {
            eventLabel: `${payload.gtm_event_name}_fail`,
            eventValue: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
          },
          {
            label: `${payload.gtm_event_name}_fail`,
            value: Vue.prototype.$gaHelper.getDepositValue(payload.amount),
          },
        );
      })
      .finally(() => {
        commit('depositStore/setPostDepositLoading', false, { root: true });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
